import React from 'react'
import { useState } from 'react';
import Footer from '../elements/Footer.js';
import '../CSS/Welcome.css'
import {useLocation, useNavigate} from "react-router-dom";
export default function Welcome() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleLoginRedirect = () => {
    // window.location.href = "/login";
    const token = new URLSearchParams(location.search).get('token');
    if (token) {
      sessionStorage.setItem('authToken', token);
      navigate('/');
    } else {
      window.location.href = `https://auth.jiricech2059.com/login?from=${window.location.origin}`;
    }
  }
  return (
    <div className="mainContent" id="mainContent">
      <div className="welcomeContent">
        <h1 className="welcomeTitle">Welcome to the <span className="welcomeTitleSpan">To-Do Lists</span> <span className="welcomeTitleSpan2">|</span> <span className="welcomeTitleSpan3">‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎ ‎</span> <span className="welcomeTitleSpan4">powered by Jiricech2059 Services</span></h1>
        {/*<p className="welcomeSubTitle">Search for images using the search bar above</p>*/}
        <p className="welcomeSubTitle">To use our app, you need to login first</p>
        <button className="welcomeLoginButton" onClick={handleLoginRedirect}>Login</button>
      </div>
    </div>
  )
}

